// Haptic feedback for in-app gestures. `@capacitor/haptics` ships in the iOS wrapper; it is reached by name so this
// package takes no dependency on it (the nfc.ts pattern).
import { Capacitor, registerPlugin } from "@capacitor/core";

interface HapticsPlugin {
  impact(options: { style: "LIGHT" | "MEDIUM" | "HEAVY" }): Promise<void>;
}

const Haptics = registerPlugin<HapticsPlugin>("Haptics");

/**
 * The tap a press-and-hold gives when it takes (ART-269) — what iOS does when a long press opens a context menu, so
 * the finger knows the hold registered before the sheet has finished appearing. No-op off native or without the
 * Haptics plugin.
 */
export function holdHaptic(): void {
  if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable("Haptics")) return;
  void Haptics.impact({ style: "MEDIUM" }).catch(() => {});
}
